<app-dialog-header title="Resource Availability Audit Viewer (ID {{ data.availabilityId }})"
  (closeClicked)="onCloseClick()">
</app-dialog-header>

<mat-dialog-content class="fullscreen-dialog" style="padding-top: 32px; height: 800px;">
  <div
    style="padding: 16px 24px 24px 24px; display: flex; align-items: center; border-bottom: 1px solid #e0e0e0; margin-bottom: 24px;">
    <mat-checkbox (change)="updateIncludeSystem($event, auditGrid)" color="primary">Include System</mat-checkbox>
  </div>

  <div style="padding: 0 24px;">
    <app-grid #auditGrid [autoHeight]=true [cellEdit]="false" [columns]="auditColumns" [filter]="true"
      [rowExpander]="rowExpanderConfig" [showRemoveRowInContextMenu]="false" [width]="'100%'"></app-grid>
  </div>

</mat-dialog-content>